import { FC } from "react";
import { FormControl, Autocomplete, TextField, Chip, Box } from "@mui/material";
import styles from './MultiSelectField.module.css';

// Interface padronizada para as opções
interface Option {
  group: string;
  name: string;
}

interface MultiSelectGroupFieldProps {
  label: string;
  value: Option[];
  //onChange: (value: string[]) => void;
  onChange: (value: Option[]) => void;
  //options: { group: string; name: string }[];
  options: Option[];
  required?: boolean;
  fullWidth?: boolean;
  maxSelections?: number;
  keyGroup?: string;
  nameOption?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
}

const MultiSelectGroupField: FC<MultiSelectGroupFieldProps> = ({
  label,
  value,
  onChange,
  options,
  required,
  fullWidth = true,
  maxSelections = 9999,
  error,
  helperText,
  disabled = false,
}) => {

  const isOptionDisabled = (option: Option) => {
    // 2. Tipagem Corrigida: Garante que 'option' é Option, e a inclusão verifica objetos
    return value.length >= maxSelections && !value.some(v => v.name === option.name);
  };

  return (
    <FormControl fullWidth={fullWidth}>
      <Autocomplete
        slotProps={{
          paper: {
            className: styles.paper,
          },
          popper: {
            className: styles.popper,
          },
        }}
        multiple
        options={options}
        disabled={disabled}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name}
        groupBy={(option) => option.group} 
        getOptionDisabled={isOptionDisabled}
        value={value}
        onChange={(_, newValue: Option[]) => onChange(newValue)}
        filterSelectedOptions
        renderInput={(params) => (
          <>
            <label className={styles.titleInput}>
              {label}
            </label>
            <TextField
              {...params}
              label=""
              variant="standard"
              placeholder={options.length > 0 ? '' : 'Selecione'}
              required={required}
              fullWidth={fullWidth}
              error={error}
              helperText={helperText}
              InputProps={{
                ...params.InputProps,
                className: styles.inputSelect, // estiliza o input real
                disableUnderline: true,
              }}
              InputLabelProps={{
                className: styles.labelSelect, // estiliza o label
                shrink: true,
              }}
            />
          </>
        )}
        renderTags={(selected: Option[], getTagProps) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.2 }}>
            {selected.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.name} label={option.name} />
            ))}
          </Box>
        )}
      />
    </FormControl>
  );
};

export default MultiSelectGroupField;
